  <h2 mat-dialog-title>{{ 'jobApply.title' | translate }}</h2>
  <mat-dialog-content>
    <mat-label>{{ 'jobApply.messageLabel' | translate }}</mat-label>
    <app-input-area
      [isEditable]="true"
      [withSubmit]="false"
      (text)="onMessageChange($event)">
    </app-input-area>

    <div class="checkbox-container">
      <mat-checkbox [(ngModel)]="includeCV" color="primary">
        {{ 'jobApply.includeCV' | translate }}
      </mat-checkbox>
    </div>
  </mat-dialog-content>

  <div class="buttons">
    <app-button
      [label]="'common.cancel' | translate"
      [leftIcon]="'assets/Left-icon.png'"
      [size]="ButtonSize.LARGE"
      (click)="close()"
      [state]="ButtonState.REGULAR"
      [type]="ButtonType.SECONDARY">
    </app-button>
    <app-button
      (click)="submit()"
      [label]="'jobApply.submit' | translate"
      [size]="ButtonSize.LARGE"
      [state]="ButtonState.REGULAR"
      [type]="ButtonType.PRIMARY">
    </app-button>
  </div>

